import React from 'react';
import { PaymentFulfillmentChannelsEnum } from 'types/generated/client';
import Header from './Header';
import { Event } from '../types';
import { formatDate } from '../utils';

interface Props {
  event: Event;
}

export default function Canceled({ event }: Props) {
  const isOnPlatform =
    event.paymentFulfillmentChannel === PaymentFulfillmentChannelsEnum.OnPlatform;
  const isPaid = (event.registrationPriceUnitAmount ?? 0) > 0;

  return (
    <>
      <Header title="Event cancelled" className="px-6 pt-6" />
      <div className="tournament-register-form flex w-full flex-col items-start gap-4 rounded-lg p-6 shadow-md">
        <p className="typography-product-body text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          The organizer cancelled this event
          {event.canceledAt ? ` on ${formatDate({ date: event.canceledAt })}` : ''}. Registration is
          closed.
        </p>
        {!!event.cancelReason && (
          <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            {event.cancelReason}
          </p>
        )}
        {isPaid && isOnPlatform && (
          <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Players who paid on Bounce have been refunded to their original payment method.
          </p>
        )}
      </div>
    </>
  );
}
